


















































































































































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import moment from 'moment';
import DateFormat from '@/shared/utils/date-format';
import { BillingType } from '@/shared/utils/billing-type.enum';
import Rules from '@/shared/rules/rules';
import MainButton from '@/shared/buttons/main-button.component.vue';
import SelectBillingType from '@/shared/billing-type/select-billing-type.component.vue';
import SelectMultipleMonth from '@/shared/date-picker/multiple-months/select-multiple-month.component.vue';
import SelectSingleMonth from '@/shared/date-picker/single-month/select-single-month.component.vue';

@Component({
  components: {
    MainButton,
    SelectBillingType,
    SelectMultipleMonth,
    SelectSingleMonth,
  },
})
export default class PerformBillingModalFields extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: boolean;

  @Prop({ type: String, required: true }) executionType!: string;

  @Prop({ type: Array, required: true }) competences!: string[];

  @Prop({ type: String, required: true }) startDate!: string;

  @Prop({ type: String, required: true }) endDate!: string;

  @Prop({ type: String, required: true }) invoiceCompetence!: string;

  @Prop({ type: Boolean, default: false }) billingDaily!: boolean;

  @Prop({ type: Boolean, default: false }) simulation!: boolean;

  @Prop({ type: Boolean, default: false }) compact!: boolean;

  rules: Rules = new Rules();

  updateExecutionType(executionType: string): void {
    this.$emit('update:executionType', executionType);
  }

  updateCompetences(competences: string[]): void {
    competences.sort();
    this.$emit('update:competences', competences);
  }

  updateStartDate(startDate: string): void {
    this.$emit('update:startDate', startDate);
  }

  updateEndDate(endDate: string): void {
    this.$emit('update:endDate', endDate);
  }

  updateInvoiceCompetence(invoiceCompetence: string): void {
    this.$emit('update:invoiceCompetence', invoiceCompetence);
  }

  allowedPeriodsValidator(period: string): boolean {
    const nextMonth = moment().add(1, 'month');
    const validatingPeriod = moment(period, 'YYYY-MM');
    return validatingPeriod.isSameOrBefore(nextMonth);
  }

  dateAsText(date: string): string {
    if (!date) return '';
    return DateFormat.standardDate(date);
  }

  competenceLabel(): string {
    const competenceLabel = 'Competência';
    return this.simulation ? competenceLabel : `${competenceLabel} da Nota`;
  }

  confirmButtonLabel(): string {
    return this.simulation ? 'Simular' : 'Executar';
  }

  belongsToFirstCompetence(startDate: string): boolean | string {
    if (startDate === '') return true;
    const firstCompetence = this.getSortedCompetences()[0];
    const valid = firstCompetence === `${startDate.substring(6)}-${startDate.substring(3, 5)}`;
    return valid || 'Deve pertencer ao primeiro mês dos períodos selecionados acima';
  }

  belongsToLastCompetence(endDate: string): boolean | string {
    const lastCompetence = this.getSortedCompetences()[this.competences.length - 1];
    const valid = lastCompetence === `${endDate.substring(6)}-${endDate.substring(3, 5)}`;
    return valid || 'Deve pertencer ao último mês dos períodos selecionados acima';
  }

  isBeforeEndDate(startDate: string): boolean | string {
    if (startDate === '') return true;
    if (this.endDate === '') return true;
    return moment(startDate, 'DD/MM/YYYY').isSameOrBefore(moment(this.endDate, 'YYYY-MM-DD'))
      || 'A data inicial não pode ser posterior à data final.';
  }

  getSortedCompetences(): Array<string> {
    const competencesCopyToAvoidDataMutation = [...this.competences];
    return competencesCopyToAvoidDataMutation.sort();
  }

  allowedStartDatesValidator(startDate: string): boolean {
    if (this.competences.length === 0) return false;
    const firstCompetence = this.getSortedCompetences()[0];
    const startDateMonthBegin = moment(`${firstCompetence}-01`, 'YYYY-MM-DD');
    const startDateMonthEnd = moment(startDateMonthBegin);
    startDateMonthEnd.endOf('month');
    const validatingStartDate = moment(startDate, 'YYYY-MM-DD');
    return validatingStartDate.isSameOrAfter(startDateMonthBegin)
      && validatingStartDate.isSameOrBefore(startDateMonthEnd);
  }

  allowedEndDatesValidator(endDate: string): boolean {
    if (this.competences.length === 0) return false;
    const lastCompetence = this.getSortedCompetences()[this.competences.length - 1];
    const endDateMonthBegin = moment(`${lastCompetence}-01`, 'YYYY-MM-DD');
    const endDateMonthEnd = this.getLastEndDateAllowed(endDateMonthBegin);
    const validatingEndDate = moment(endDate, 'YYYY-MM-DD');
    return validatingEndDate.isSameOrAfter(endDateMonthBegin)
      && validatingEndDate.isSameOrBefore(endDateMonthEnd);
  }

  getLastEndDateAllowed(lastMonthBegin: moment.Moment): moment.Moment {
    if (this.lastCompetenceIsVigent) {
      return moment();
    }
    return moment(lastMonthBegin).endOf('month');
  }

  isLastCompetenceVigent(): boolean {
    const sortedCompetences = this.getSortedCompetences();
    const lastCompetence = sortedCompetences[this.competences.length - 1];
    return lastCompetence === moment().format('YYYY-MM');
  }

  cancel(): void {
    this.$emit('cancel');
  }

  execute(): void {
    this.$emit('execute');
  }

  get lastCompetenceIsVigent(): boolean {
    if (this.competences.length === 0) return false;
    return this.isLastCompetenceVigent();
  }

  get isSingle() {
    return this.executionType === BillingType.SINGLE;
  }
}
